import { Controller, useFormContext } from 'react-hook-form'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_m14, Noto_body3_m12 } from 'src/styles/fonts/NotoSansKrFonts'
import Button, { ButtonOption1 } from 'src/components/common/Button'
import React from 'react'
import { SelfRegCouponCreatePageProps } from 'src/pages/SelfRegCouponPage/SelfRegCouponCreatePage'
import styled, { css } from 'styled-components'
import { SelfRegisterCouponFormItemsType } from 'src/types/react-hook-form'
import RenderIf from 'src/components/common/RenderIf'

const SelfRegCreateController = ({
  selfRegImageDeleteHandler,
  registerAttribute,
  requestSelectImageHandler,
}: Pick<
  SelfRegCouponCreatePageProps,
  'registerAttribute' | 'selfRegImageDeleteHandler' | 'requestSelectImageHandler'
>) => {
  const { control } = useFormContext<SelfRegisterCouponFormItemsType>()
  const { couponImage } = registerAttribute
  return (
    <Controller
      control={control}
      name={'couponImage'}
      render={({ field, formState }) => {
        const { value } = field
        const { defaultValues } = formState
        const initialValue = value === defaultValues?.couponImage
        const imgSize = initialValue ? '80px' : 'auto'
        return (
          <Container>
            <Container $style={S.SelfRegImageBg}>
              <S.SelfRegImageWrap>
                <S.SelfRegFileUploader
                  onClick={requestSelectImageHandler}
                  onChange={couponImage.register_options!?.onChange}
                  accept=".pdf, .jpg, .png, .jpeg, .bmp, .gif, .tif, .tiff, .svg"
                />
                <S.SelfRegImage src={value} alt="coupon img" $size={imgSize} />
                <RenderIf when={initialValue}>
                  <Container $option="flex_column" $row_gap="10px">
                    <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
                      쿠폰 이미지 올리기
                    </Typography>
                    <Typography $fontStyle={Noto_body3_m12} $color="var(--black-40)">
                      미등록 시 바코드 이미지가 자동생성 됩니다.
                    </Typography>
                  </Container>
                </RenderIf>
              </S.SelfRegImageWrap>
            </Container>
            <RenderIf when={!initialValue}>
              <Container $style={S.SelfRegImageDeleteButtonWrap} $option="flex_row">
                <Button option={ButtonOption1('default')} onClickFn={selfRegImageDeleteHandler}>
                  이미지 삭제
                </Button>
              </Container>
            </RenderIf>
          </Container>
        )
      }}
    />
  )
}
export default SelfRegCreateController

const S = {
  SelfRegImageBg: css`
    background-color: var(--black-10);
  `,
  SelfRegImageDeleteButtonWrap: css`
    display: flex;
    margin-top: 20px;
    padding: 0 20px;
  `,
  SelfRegFileUploader: styled.input.attrs({ type: 'file' })`
    //width: 360px;
    height: 360px;
    max-height: 360px;
    position: absolute;
    z-index: 1;
    color: transparent;

    &::file-selector-button {
      display: none;
    }
  `,
  SelfRegImageWrap: styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    //width: 360px;
    height: 360px;
    gap: 10px;
    margin: 0 auto;
    background-color: var(--black-4);
  `,
  SelfRegImage: styled.img<{ $size: string }>`
    width: ${(props) => props.$size};
    height: auto;
    max-height: 360px;
    max-width: 360px;
  `,
}
